import {bindActionCreators} from 'redux'
import {connect} from '../../redux/utils'
import {
    canManage, getAllCommentsUserIds,
    getComments,
    getCommentsCount,
    getCommentsScrollTo,
    getEditingCommentId,
    getEditingCommentText,
    getRecentlyAddedCommentsIds,
    getUpdatingCommentId,
    getUsers,
    isCommentsLoading,
    isCommentsReadOnly,
    isNewCommentsOnTop,
    isSendingComment
} from './selectors'
import {getLoggedInUser} from '../../loggedInUser/selectors'
import {commentsActions, commentsServiceActions} from './actions'
import CommentsSection from '../comments/CommentsSection'

export default connect(
    state => ({
        comments: getComments(state),
        users: getUsers(state),
        commentsCount: getCommentsCount(state),
        allCommentsUserIds: getAllCommentsUserIds(state),
        loggedInUser: getLoggedInUser(state),
        isNewCommentsOnTop: isNewCommentsOnTop(state),
        recentlyAddedCommentsIds: getRecentlyAddedCommentsIds(state),
        commentsScrollTo: getCommentsScrollTo(state),
        editingCommentId: getEditingCommentId(state),
        editingCommentText: getEditingCommentText(state),
        loading: isCommentsLoading(state),
        sendingComment: isSendingComment(state),
        updatingCommentId: getUpdatingCommentId(state),
        readOnly: isCommentsReadOnly(state),
        canManage: canManage(state),
    }),
    dispatch => ({
        loadMoreComments: bindActionCreators(commentsServiceActions.loadMoreComments, dispatch),
        saveComment: bindActionCreators(commentsServiceActions.saveComment, dispatch),
        deleteComment: bindActionCreators(commentsServiceActions.deleteComment, dispatch),
        changeCommentsOrder: bindActionCreators(commentsActions.changeCommentsOrder, dispatch),
        resetCommentsScrollTo: bindActionCreators(commentsActions.resetCommentsScrollTo, dispatch),
        startEditComment: bindActionCreators(commentsServiceActions.startEditComment, dispatch),
        cancelEditComment: bindActionCreators(commentsActions.cancelEditComment, dispatch),
        updateEditingCommentText: bindActionCreators(commentsActions.updateEditingCommentText, dispatch),
        saveEditingComment: bindActionCreators(commentsServiceActions.saveEditingComment, dispatch),
    })
)(CommentsSection)


// WEBPACK FOOTER //
// ./web/js/panels/customer/CommentsSection.js